import React from 'react';

import { useViewport } from '@shared/hooks/useViewport';
import { SuccessMessage as SuccessMessageDefault } from '../SuccessMessage';
import { DrivingSchoolsType } from './constants';
import { SuccessMessageWithOffer } from './SuccessMessageWithOffer';
import { RESOLUTION } from '../../../constants';

type SuccessMessageProps = {
  placeId: string;
  rating: number;
  reviewId: string;
  firstName: string;
  selectedSchoolType: DrivingSchoolsType;
  city: string;
  zipcode: string;
  phone: string;
  email: string;
  isLeadsFormSent: boolean;
};

const SuccessMessage = (props: SuccessMessageProps) => {
  const {
    placeId, rating, reviewId, firstName, selectedSchoolType, city, zipcode, phone, email, isLeadsFormSent,
  } = props;
  const { viewportWidth } = useViewport();

  return (
    selectedSchoolType === DrivingSchoolsType.TRADITIONAL || viewportWidth <= RESOLUTION.LARGE
      ? (
        <SuccessMessageDefault
          text={viewportWidth <= RESOLUTION.LARGE && isLeadsFormSent ? 'Vous allez être recontacté(e) prochainement par une auto-école proche de chez vous.' : ''}
          title={`${firstName}, merci pour votre avis!`}
          placeId={placeId}
          rating={rating}
          reviewId={reviewId}
          isExamCenter
        />
      )
      : (
        <SuccessMessageWithOffer
          city={city}
          zipcode={zipcode}
          phone={phone}
          firstName={firstName}
          placeId={placeId}
          rating={rating}
          reviewId={reviewId}
          email={email}
        />
      )
  );
};

export { SuccessMessage };
